import * as yup from 'yup'
import TipeSurat from '../../enums/tipeSurat'

export const addVehicleTransportReportValidation = yup.object().shape({
    tipe: yup.string().required('Harus diisi'), 
    companyId: yup.string().required('Harus diisi'), 
    nomorSuratRekomendasi: yup.string().when('tipe', {
        is: (val) => val !== TipeSurat.BARU,
        then: (schema) => schema.required('Harus diisi'),
        otherwise: (schema) => schema.notRequired(),
    }), 
    tanggalSuratRekomendasi: yup.string().when('tipe', {
        is: (val) => val !== TipeSurat.BARU,
        then: (schema) => schema.required('Harus diisi'),
        otherwise: (schema) => schema.notRequired(),
    }), 
    nomorSuratPerusahaan: yup.string().required('Harus diisi'), 
    tanggalSuratPerusahaan: yup.string().required('Harus diisi'), 
    file: yup.mixed().required('Harus diisi')
        .test("fileType", "Format harus excel", (file) => {
            if (!file) return false;
            return file[0]?.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
}).required()